
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

var $1601d2a8f610537f$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"bbnaa\",\"GlobalFeedbackCollector.35afd990.js\",\"6KGrg\",\"EmojiComponent.6a24c3fe.js\",\"ffEVr\",\"vendors~editor_icon.73c6860b.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.73c6860b.js\",\"iPz8n\",\"GlobalFeedbackCollector.f97cd845.js\",\"1RolH\",\"EmojiPickerComponent.33a787e5.js\",\"aHE9G\",\"vendors~editor_atlaskit.130c51f9.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.68ce65ca.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"6Y8Qe\",\"panel.2a491281.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"9gJO7\",\"modal.9b95c189.js\",\"6cVEd\",\"fire-event.32c1479b.js\",\"aZinD\",\"vendors.51896174.js\",\"4SIAe\",\"ReadTimePopup.8c7ccf14.js\",\"cf51e\",\"modal.692034ac.js\",\"iXBG8\",\"modal.runtime.ba2a39c8.js\",\"iXBG8\",\"modal.runtime.ba2a39c8.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.1b7a934b.js\",\"1S9KM\",\"lock-locked--lock-circle.11c51b01.js\",\"bL008\",\"lock-circle.fdb473df.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.68ce65ca.js\",\"6ZETc\",\"smart-link.587c04b9.js\",\"8qEcu\",\"FullPageEditorComponent.41d63223.js\",\"1qLpu\",\"FullPageEditorComponent.runtime.7dd16003.js\",\"1qLpu\",\"FullPageEditorComponent.runtime.7dd16003.js\",\"1lvsb\",\"EmojiTitlePopover.91f111d1.js\",\"9Zd2C\",\"EmojiTitleButton.40c89c4b.js\",\"dGk3x\",\"GlobalFeedbackCollector.5c3e76a5.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"c6MKV\",\"stable_vendors.37f43bb6.js\",\"cyGuT\",\"feedback-collector.b1919a90.js\",\"aHE9G\",\"vendors~editor_atlaskit.130c51f9.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.68ce65ca.js\",\"aZinD\",\"vendors.51896174.js\",\"c6MKV\",\"stable_vendors.37f43bb6.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"XgRtr\",\"EmojiPicker.957ee883.js\",\"2F69B\",\"vendors~small-pkgs.5c0aab02.js\",\"4hZJd\",\"EmojiTitleSelection.95a0b4f4.js\",\"hUvv7\",\"LiveDocsDefaultIcon.2e1b14cc.js\"]"));


//# sourceMappingURL=GlobalFeedbackCollector.runtime.d3e2cfc1.js.map
